/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const UpdateMyNotificationPreferenceBody = zod.object({
  emailEnabled: zod
    .boolean()
    .optional()
    .describe('Whether notification emails for this topic should be delivered'),
  inAppEnabled: zod
    .boolean()
    .optional()
    .describe('Whether this topic appears in the in-app notification feed (the bell)'),
  pushEnabled: zod
    .boolean()
    .optional()
    .describe('Whether pushes for this topic should be delivered'),
  smsEnabled: zod
    .boolean()
    .optional()
    .describe('Whether notification SMS for this topic should be delivered'),
});

export type UpdateMyNotificationPreferenceBody = zod.input<
  typeof UpdateMyNotificationPreferenceBody
>;
export type UpdateMyNotificationPreferenceBodyOutput = zod.output<
  typeof UpdateMyNotificationPreferenceBody
>;
